export default {
  data() {
    return {
      timer: '', // 计时器
      time: 60,
      phoneClock: false // 手机号输入框是否禁止输入，true禁止输入
    };
  },
  computed: {
    // 按钮文字
    msgCodeText() {
      return this.timer ? this.time + '秒' : '获取验证码';
    }
  },
  methods: {
    // 重置倒计时
    resetTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.time = 60;
      this.phoneClock = false;
    },
    // 获取验证码倒计时
    countDown(s = 60) {
      console.log('启动了');
      this.time = s;
      this.phoneClock = true;
      this.time--;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.phoneClock = false;
        }
      }, 1000);
    }
  }
};
